import react from "react";
import reactDom from "react-dom";
import {Routes,BrowserRouter as Router, Route, Link} from 'react-router-dom';
import {Layout, Typography,Space, Result,Button} from 'antd';
import { NavBar, HomePage, Cryptocurrencies, News, Exchanges ,CryptoDetails} from "./components";
import './App.css';
import { useGetCryptosQuery } from "./components/sevices/cryptoApi";


const App=()=>{

return (

    <div className="app">
            <div className="navbar">
                <NavBar/>
            </div>
        <div className="main">
            <Layout>
                <div className="routes">
                     <Routes>
                            <Route  exact path="/" element={<HomePage/>}/>
                            <Route  exact path="/cryptocurencies" element={<Cryptocurrencies/>}/>
                            <Route  exact path="/exchanges" element={<Exchanges/>}/>
                            <Route  exact path="/news" element={<News/>}/>
                            <Route  path="/crypto/:coinId" element={<CryptoDetails/>}/>
                            <Route  path="*" 
                                    element={ <Result   status="404" title="404"
                                    subTitle="Sorry, the page you visited does not exist."
                                    extra={<Link to='/'><Button type="primary">Back Home</Button></Link>}/>} />
                     </Routes>
               
                </div>
            </Layout>
            <div className="footer">
                <Typography.Title level={5} style={{color:"white" , textAlign:"center"}}>
                    CryptWorld <br/>
                    All Rigths Reserved
                </Typography.Title>
                <Space>
                    <Link to="/"> Home </Link>
                    <Link to="/exchanges"> Exchanges </Link>
                    <Link to="/news"> News </Link>
                </Space>
               
             </div>

        </div>
        
       
    </div>

)
}

export default App;